
  import { Component, Prop, Vue } from "vue-property-decorator";
  import RouteNames from "@/entities/RouteNames";
  import Roles from "@/entities/Roles";
  import ItemChip from "@/components/common/ItemChip.vue";
  import EmployeeRemovedFromCompanyTooltip from "@/components/tooltip/EmployeeRemovedFromCompanyTooltip.vue";
  import RouteParams from "@/entities/RouteParams";
  import { Contractor, Manager } from "@/generated/graphql";
  import { getSectionRouteName } from "@/helpers/routes/getSectionRouteName";
  import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";

  @Component({
    components: {
      EmployeeRemovedFromCompanyTooltip,
      ItemChip,
    },
  })
  export default class DocumentUserInformation extends Vue {
    @Prop({ type: String, required: true }) readonly userFirstName!: string;
    @Prop({ type: String, required: true }) readonly userLastName!: string;
    @Prop({ type: String, required: true }) readonly userRole!: string;
    @Prop({ type: String, required: true }) readonly userId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: Roles;
    @Prop({ type: String, default: undefined }) readonly userAvatar?: string;
    @Prop({ type: Object, default: () => ({}) }) readonly manager?: Manager;
    @Prop({ type: Array, default: () => [] }) readonly contracts?: Contractor[];

    get employeeRemoved(): boolean {
      if (!this.contracts) {
        return false;
      }

      return Boolean(this.contracts[0]?.deleted);
    }

    get routeParams(): RouteParams<{ id: string }> | undefined  {
      if (this.isAdmin || this.currentUserRole === Roles.CONTRACTOR) {
        return;
      }

      if (this.userRole === Roles.MANAGER) {
        return {
          name: RouteNames.MANAGER_ABOUT,
          params: {
            id: this.manager!.id,
          }
        };
      }

      if (!this.contracts || this.contracts.length === 0) {
        return;
      }

      const { deleted, id: contractorId, managers } = this.contracts[0];
      const { approved } = managers[0];

      if (this.currentUserRole === Roles.ADMIN) {
        if (deleted) {
          return {
            name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
            params: {
              id: this.userId,
            },
          };
        }

        return {
          name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
          params: {
            id: contractorId,
          },
        }
      }

      if (this.currentUserRole === Roles.MANAGER) {
        if (deleted) {
          return {
            name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
            params: {
              id: this.userId,
            },
          };
        }

        if (!approved) {
          return {
            name: getSectionRouteName({
              routeName: RouteNames.CONTRACTOR_PUBLIC_PAGE,
              prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
            }),
            params: {
              id: this.userId,
            },
          };
        }

        return {
          name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
          params: {
            id: contractorId,
          },
        };
      }
    }

    get isAdmin(): boolean {
      return this.userRole === Roles.ADMIN;
    }

    get fullName(): string {
      return `${this.userFirstName} ${this.userLastName}`;
    }

    get initials(): string {
      return `${this.userFirstName[0]}${this.userLastName[0]}`;
    }
  }
